import { render, staticRenderFns } from "./yiban.vue?vue&type=template&id=7ef19f2d&scoped=true&"
import script from "./yiban.vue?vue&type=script&lang=js&"
export * from "./yiban.vue?vue&type=script&lang=js&"
import style0 from "./yiban.vue?vue&type=style&index=0&id=7ef19f2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef19f2d",
  null
  
)

export default component.exports